// Utils > Number

/**
 * returns an array of values from number 1 to number 2
 * @param n1
 * @param n2
 * @param inclusive
 */
export function range(
	n1: number = 0,
	n2: number,
	inclusive: boolean = true,
	inc: number = 1
): number[] {
	const max = Math.max(n1, n2)
	const min = Math.min(n1, n2)
	let size = (max - min) / inc

	if (inclusive) size++

	return [...Array(size).keys()].map(i => i + min)
}

export const randomInteger = (): number => {
	return Math.floor(Math.random() * 100000000000000000)
}

export const closestToNumber = (a: number[], target: number): number => {
	return a.reduce(function(prev: number, curr: number) {
		return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev
	})
}
